import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import classNames from 'classnames';
import DataContainer from 'Components/UI/DataContainer';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import relationships from 'Consts/Relationships';
import { useMeetingContext } from 'Context/MeetingContext';
import { TemplatesProvider } from 'Context/TemplateContext';
import fr from 'facet-rest';
import useUserContext from 'Context/UserContext';
import useMissionControlMeetingEffect from '../../useMissionControlMeetingEffect';
import useMissionControl from '../../useMissionControl';
import { EmailView } from './EmailView';

const styles = () => ({
  container: {}, // This style is only applied to the DataContainer
  root: {},
});

const EmailContainer = ({
  className,
  classes,
  openTabs,
  openTab,
  setActiveTab,
}) => {
  const { agentResource } = useUserContext();
  const { householdResource } = useSimpleHousehold();
  const { meetingResource, meetingLoadingError } = useMeetingContext();
  const { noMeetings } = useMissionControl();
  const [meetingTemplateCollection, setMeetingTemplateCollection] = useState(null);
  const [loadingMeetingTemplateCollectionError, setLoadingMeetingTemplateCollectionError] = useState(null);

  const refreshMeetingTemplateCollection = async (ceResource) => {
    try {
      const res = await ceResource
        .relationship(relationships.meetingTemplates)
        .link('related')
        .get();

      setMeetingTemplateCollection(res);
    } catch (err) {
      setLoadingMeetingTemplateCollectionError(err);
    }
  };

  useMissionControlMeetingEffect(async () => {
    await refreshMeetingTemplateCollection(meetingResource);
  });

  const isLoading = !meetingResource || !meetingTemplateCollection;
  const loadingError = meetingLoadingError || loadingMeetingTemplateCollectionError;

  if (isLoading) {
    return null;
  }

  // If there are no meetings then don't return anything on this tab
  if (noMeetings) {
    return null;
  }

  return (
    <TemplatesProvider
      templatesLinkUrl={meetingResource?.relationship(fr.relationships.personalEmailTemplates.name).link('related').url()}
      pinnedTemplatesLinkUrl={agentResource?.relationship(fr.relationships.pinnedMeetingTemplates.name).link('related').url()}
    >
      <DataContainer
        className={classes.container}
        component={EmailView}
        componentProps={{
          className: classNames(classes.root, className),
          householdResource,
          meetingResource,
          meetingTemplateCollection,
          onSaveMeetingTemplate: () => refreshMeetingTemplateCollection(meetingResource),
          openTabs,
          openTab,
          setActiveTab,
        }}
        loading={isLoading}
        loadingError={loadingError}
      />
    </TemplatesProvider>
  );
};

EmailContainer.defaultProps = {
  className: '',
};

EmailContainer.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  openTabs: PropTypes.array.isRequired,
  openTab: PropTypes.func.isRequired,
  setActiveTab: PropTypes.func.isRequired,
};

export default withStyles(styles)(EmailContainer);
